namespace Areas.Warranty.Profile {
    "use strict";

    export function onNewWarrantyItemRow(e: any) {
        const data = e.data;
        data.warrantyProfileId = e.component.option("WarrantyProfileId");
    }

    export function returnToListFromTab() {
        var linkInfo = "/Warranty/List/Active";
        location.href = linkInfo;

    }

    // select account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#WarrantyProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.AccountId = data.accountId;
            formData.AccountName = data.accountName;
            formData.ProjectCCNumber = data.projectCCNumber;

            form.option("formData", formData);

        }
    }

    export function selectAccount() {
        const form: any = $("#WarrantyProfileForm").dxForm("instance");
        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }

    export function actionSelected(accountId: number) {
        return (e: any) => {
            if (e.value == 1) { gotoAccountProfileViaWarranty(accountId); return; }
        }
    }


    function gotoAccountProfileViaWarranty(accountId: number) {
        sendRequest(`/Warranty/Profile/GotoAccountProfileViaWarranty/${accountId}`, null, "PUT");
    }

}